import React from 'react'
import ReactDOM from 'react-dom'
import {localsMessages} from '../utility/getTemplateData'

let messages = localsMessages('common/nextButton')
let PropTypes = React.PropTypes

export default React.createClass({

    propTypes:{
        label: React.PropTypes.string
    },

    getInitialState () {
        return {};
    },

    render () {

        let buttonnext = messages.button && messages.button.next

        return (
        	<div className="col-xs-12 col-sm-12 col-md-12 text-center pp_next_btn_wrapper">
                <a className="btn btn-primary pp_next_btn" id="payWithPP" onClick={this.props.handleNext}>{buttonnext}</a>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./common/nextButton.js
 **/